export default "__VITE_ASSET__Bbp627Rm__"